export const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let index = shuffled.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(Math.random() * (index + 1));
    [shuffled[index], shuffled[swapIndex]] = [shuffled[swapIndex], shuffled[index]];
  }
  return shuffled;
};

export const shuffleDifferentOrder = (array) => {
  const original = [...array];
  const shuffled = shuffleArray(original);
  if (
    shuffled.length > 1
    && shuffled.every((item, index) => item === original[index])
  ) {
    shuffled.push(shuffled.shift());
  }
  return shuffled;
};

export const getCleanWord = (word) => {
  if (!word) return '';
  const match = word.match(/^([a-zA-Z\s-]+)/);
  return match ? match[1] : word;
};

export const practiceAudioRequests = (items) => {
  const words = [];
  const sentences = [];
  (items || []).forEach((item) => {
    const word = getCleanWord(item?.word);
    if (word) words.push({ text: word, mode: 'word' });
    (item?.exercises || []).forEach((exercise) => {
      if (exercise?.type === 'infer_meaning' && exercise.sentence) {
        sentences.push({ text: exercise.sentence, mode: 'sentence' });
      } else if (exercise?.type === 'sentence_reordering' && exercise.sentence_answer) {
        sentences.push({ text: exercise.sentence_answer, mode: 'sentence' });
      } else if (exercise?.type === 'synonym_replacement' && exercise.sentence) {
        sentences.push({ text: exercise.sentence, mode: 'sentence' });
      }
    });
  });
  return { words, sentences };
};

export const generateDistractors = (currentItem, allItems, count, type = 'word') => {
  const currentRoot = currentItem.word_root;

  // Level 1: Different root word
  let pool = allItems.filter(item => item.word_root !== currentRoot);

  // Level 2: If pool is too small, allow same root as fallback
  if (pool.length < count) {
    const sameRootPool = allItems.filter(item => item.word_root === currentRoot && item.word !== currentItem.word);
    pool = [...pool, ...sameRootPool];
  }

  // Level 3: If still too small, fill with anything except the exact same word
  if (pool.length < count) {
    const anyOtherPool = allItems.filter(item => item.word !== currentItem.word);
    pool = [...pool, ...anyOtherPool];
  }

  // Ensure uniqueness
  const uniquePool = Array.from(new Set(pool.map(p => p.word))).map(w => allItems.find(i => i.word === w));

  const distractors = shuffleArray(uniquePool).slice(0, count);

  if (type === 'definition') {
    return distractors.map(i => i.definition.cn);
  }
  return distractors.map(i => i.word);
};

export const isPureEnglish = (text) => {
  if (!text) return false;
  const letters = (text.match(/[A-Za-z]/g) || []).length;
  const han = (text.match(/[\u4e00-\u9fff]/g) || []).length;
  return letters > 0 && letters >= han * 2; // heuristic: clearly more letters than Han
};

export const zhDominates = (text) => {
  if (!text) return false;
  const han = (text.match(/[\u4e00-\u9fff]/g) || []).length;
  const letters = (text.match(/[A-Za-z]/g) || []).length;
  return han > letters; // more Chinese than English letters
};

export const createStudySessionId = () => {
  try {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID().replace(/-/g, '_');
  } catch (_) {}
  return `study_${Date.now()}_${Math.random().toString(36).slice(2, 12)}`;
};
